const DATE_FORMAT: Intl.DateTimeFormatOptions = { day: "2-digit", month: "short", year: "numeric" };

export const formatDMY = (value?: string | Date | null) => {
  if (!value) return "-";
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split("-");
    return `${day}/${month}/${year}`;
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${date.getFullYear()}`;
};

// Date-only values (yyyy-mm-dd), parsed as local to avoid timezone shifts
export const formatDate = (value: string, language: string) => {
  const [year, month, day] = value.slice(0, 10).split("-").map(Number);
  return new Date(year, month - 1, day).toLocaleDateString(language, DATE_FORMAT);
};

// Full timestamps (ISO with time)
export const formatTimestamp = (value: string | Date, language: string) =>
  new Date(value).toLocaleDateString(language, DATE_FORMAT);

export const toDateInput = (value?: string | Date | null) =>
  !value ? "" : typeof value === "string" ? value.slice(0, 10) : value.toISOString().slice(0, 10);

// Today as yyyy-mm-dd in local time
export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};